import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  activityLogWidth: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    overflowY: 'auto',
    maxHeight: '90vh',
  },
  rootContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: theme.spacing(31.75),
    gap: theme.spacing(3),
    backgroundColor: theme.palette.text.white,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(4),
  },
  titleIconContainer: {
    display: 'flex',
    height: theme.spacing(3.5),
    width: theme.spacing(3.5),
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    backgroundColor: theme.palette.bgSecondary.main,
    borderRadius: theme.spacing(0.5),
  },
  titleIcon: {
    color: theme.palette.labraText.primary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 500,
    padding: theme.spacing(0, 1),
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(3),
  },
  heading: {
    fontSize: theme.spacing(2),
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    color: theme.palette.labraText.primary,
    fontFamily: 'Poppins, sans-serif',
    letterSpacing: '0.15px',
  },
  labraIcon: {
    height: theme.spacing(9.75),
    width: theme.spacing(26.75),
  },
  labraLogoContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1.5),
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  labraLogo: {
    width: theme.spacing(14),
    height: theme.spacing(11),
  },
}))
